var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { TreeNode, TreeService } from './tree.service';
var TreeComponent = /** @class */ (function (_super) {
    __extends(TreeComponent, _super);
    function TreeComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.all_events = [
            'init.jstree',
            'loading.jstree',
            'loaded.jstree',
            'ready.jstree',
            'load_node.jstree',
            'load_all.jstree',
            'model.jstree',
            'redraw.jstree',
            'before_open.jstree',
            'open_node.jstree',
            'after_open.jstree',
            'close_node.jstree',
            'after_close.jstree',
            'open_all.jstree',
            'close_all.jstree',
            'enable_node.jstree',
            'disable_node.jstree',
            'hide_node.jstree',
            'show_node.jstree',
            'hide_all.jstree',
            'show_all.jstree',
            'activate_node.jstree',
            'hover_node.jstree',
            'dehover_node.jstree',
            'select_node.jstree',
            'changed.jstree',
            'deselect_node.jstree',
            'select_all.jstree',
            'deselect_all.jstree',
            'set_state.jstree',
            'refresh.jstree',
            'refresh_node.jstree',
            'set_id.jstree',
            'set_text.jstree',
            'create_node.jstree',
            'rename_node.jstree',
            'delete_node.jstree',
            'move_node.jstree',
            'copy_node.jstree',
            'cut.jstree',
            'copy.jstree',
            'paste.jstree',
            'clear_buffer.jstree',
            'set_theme.jstree',
            'show_stripes.jstree',
            'hide_stripes.jstree',
            'show_dots.jstree',
            'hide_dots.jstree',
            'show_icons.jstree',
            'hide_icons.jstree',
            'show_ellipsis.jstree',
            'hide_ellipsis.jstree',
            'disable_checkbox.jstree',
            'enable_checkbox.jstree',
            'check_node.jstree',
            'uncheck_node.jstree',
            'check_all.jstree',
            'uncheck_all.jstree',
            'show_contextmenu.jstree',
            'search.jstree',
            'clear_search.jstree',
            'state_ready.jstree'
        ];
        _this.plugins = [
            'checkbox',
            'wholerow',
            'changed'
        ];
        _this.tree_data = new Subject();
        _this.ignore_events = ['hover_node.jstree', 'dehover_node.jstree'];
        _this.is_control_tree_monitor = false;
        return _this;
    }
    TreeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.element = this.treeElement.nativeElement;
        this.init();
    };
    TreeComponent.prototype.tree = function () {
        return $(this.element).jstree(true);
    };
    ;
    TreeComponent.prototype.init = function () {
        var self = this;
        this.tree_data.subscribe(function (data) {
            var tree = self.tree();
            if (!tree) {
                $(self.element).jstree({
                    core: {
                        check_callback: true,
                        data: data,
                        themes: {
                            icons: false
                        }
                    },
                    checkbox: {
                        keep_selected_style: false,
                        whole_node: false,
                        tie_selection: false,
                        three_state: true
                    },
                    plugins: self.plugins
                });
            }
            else {
                tree.settings.core.data = data;
                tree.refresh(true, true);
            }
        });
        var events = this.all_events.filter(function (element) {
            return self.ignore_events.indexOf(element) == -1;
        });
        $(this.element).on(events.join(' '), function (e, data) {
            self.onEvent(e, e.type, data);
        });
    };
    TreeComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    TreeComponent.prototype.onSubscribe = function (rec) {
        if (rec instanceof Array) {
            this.org_data = rec;
            this.applyToTreeData(rec);
        }
    };
    TreeComponent.prototype.applyToTreeData = function (recs) {
        var data = [];
        for (var _i = 0, _a = recs.sort(sortByDispOrder); _i < _a.length; _i++) {
            var rec = _a[_i];
            data.push(new MenuNode(rec));
        }
        this.is_control_tree_monitor = true;
        this.tree_data.next(data);
        this.is_control_tree_monitor = false;
    };
    TreeComponent.prototype.onEvent = function (e1, e2, rec) {
        // this.logger.debug(e2);
        if (e2 === 'move_node') {
            this.beforeEvent = null;
            this.onMoveNode(rec);
        }
        else if (e2 === 'check_node') {
            this.beforeEvent = e2;
        }
        else if (e2 === 'uncheck_node') {
            this.beforeEvent = e2;
        }
        else if (e2 === 'changed') {
            this.beforeEvent = null;
            this.onChange(rec);
        }
        else if (e2 === 'activate_node') {
            if (this.beforeEvent === 'check_node') {
                this.beforeEvent = null;
                this.onCheckNode(rec);
            }
            else if (this.beforeEvent === 'uncheck_node') {
                this.beforeEvent = null;
                this.onUncheckNode(rec);
            }
        }
        else if (e2 === 'ready') {
        }
        else if (e2 === 'init') {
        }
    };
    TreeComponent.prototype.onMoveNode = function (rec) {
        var data = rec.instance._model.data;
        var root = data['#'];
        this.children(root, data);
        this.tree().redraw();
    };
    TreeComponent.prototype.applyToOrgData = function (rec, param) {
        var node = this.findById(rec.id, this.org_data);
        if (node != null) {
            node.permission = rec.state.checked;
            if (param) {
                node[param.key] = param.val;
            }
        }
        // this.action.setRec(this.org_data);
        this.action.setCompRec(this.componentName, { tree: this.org_data });
    };
    TreeComponent.prototype.findById = function (id, data) {
        if (data == null) {
            return null;
        }
        if (data instanceof Array) {
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var d = data_1[_i];
                if (d.node_id == id) {
                    return d;
                }
                var r = this.findById(id, d.children);
                if (r != null) {
                    return r;
                }
                r = this.findById(id, d.pages);
                if (r != null) {
                    return r;
                }
                r = this.findById(id, d.event);
                if (r != null) {
                    return r;
                }
            }
        }
        return null;
    };
    TreeComponent.prototype.onCheckNode = function (rec) {
        this.applyToOrgData(rec.node);
        for (var _i = 0, _a = rec.node.children_d; _i < _a.length; _i++) {
            var node = _a[_i];
            this.applyToOrgData(rec.instance._model.data[node]);
        }
        for (var _b = 0, _c = rec.node.parents; _b < _c.length; _b++) {
            var node = _c[_b];
            this.applyToOrgData(rec.instance._model.data[node], { key: 'permission', val: true });
        }
    };
    TreeComponent.prototype.onUncheckNode = function (rec) {
        this.applyToOrgData(rec.node);
        for (var _i = 0, _a = rec.node.children_d; _i < _a.length; _i++) {
            var node = _a[_i];
            this.applyToOrgData(rec.instance._model.data[node]);
        }
        for (var _b = 0, _c = rec.node.parents; _b < _c.length; _b++) {
            var node = _c[_b];
            var n = rec.instance._model.data[node];
            var boolflg = false;
            for (var _d = 0, _e = n.children; _d < _e.length; _d++) {
                var child = _e[_d];
                var childNode = this.findById(child, this.org_data);
                if (childNode != null) {
                    if (childNode.permission) {
                        boolflg = childNode.permission;
                        break;
                    }
                }
            }
            this.applyToOrgData(n, { key: 'permission', val: boolflg });
        }
    };
    TreeComponent.prototype.onChange = function (rec) {
    };
    TreeComponent.prototype.children = function (node, data) {
        for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
            var n = _a[_i];
            if (typeof data[n].li_attr.class !== 'undefined') {
                data[n].li_attr.class = parseInt(data[n].li_attr.class) + 1;
            }
            this.children(data[n], data);
        }
    };
    TreeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.tree_data.unsubscribe();
    };
    TreeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'tree',
                    template: '<div class="checkTree" #tree></div>'
                }] }
    ];
    /** @nocollapse */
    TreeComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: TreeService }
    ]; };
    TreeComponent.propDecorators = {
        treeElement: [{ type: ViewChild, args: ['tree',] }]
    };
    return TreeComponent;
}(ContentBaseComponent));
export { TreeComponent };
var MenuNode = /** @class */ (function (_super) {
    __extends(MenuNode, _super);
    function MenuNode(rec, path) {
        if (path === void 0) { path = null; }
        var _this = _super.call(this, rec) || this;
        _this.type = 'MENU';
        if (rec['id'] != null) {
            if (path) {
                _this.id = path + '/' + (_this.type + "#" + rec.id);
            }
            else {
                _this.id = _this.type + "#" + rec.id;
            }
            rec.node_id = _this.id;
        }
        if (rec['permission'] != null) {
            // 子メニューもページ定義を持たないメニューはメニューそのものの権限でチェックする
            if ((rec['pages'] == null || rec.pages.length === 0) && (rec['children'] == null || rec.children.length === 0)) {
                _this.state.checked = rec.permission;
            }
        }
        if (rec != null) {
            if (rec['pages'] != null) {
                for (var _i = 0, _a = rec['pages'].sort(sortByDispOrder); _i < _a.length; _i++) {
                    var page = _a[_i];
                    _this.children.push(new PageNode(page, _this.id));
                }
            }
            if (rec['children'] != null) {
                for (var _b = 0, _c = rec['children'].sort(sortByDispOrder); _b < _c.length; _b++) {
                    var menu = _c[_b];
                    _this.children.push(new MenuNode(menu, _this.id));
                }
            }
        }
        return _this;
    }
    return MenuNode;
}(TreeNode));
var PageNode = /** @class */ (function (_super) {
    __extends(PageNode, _super);
    function PageNode(rec, path) {
        var _this = _super.call(this, rec) || this;
        _this.type = 'PAGE';
        _this.li_attr = { class: 'checkTree_page' };
        if (rec['id'] != null) {
            _this.id = path + '/' + (_this.type + "#" + rec.id);
            rec.node_id = _this.id;
        }
        if (rec['permission'] != null) {
            // イベント定義を持たないページはページそのものの権限でチェックする
            if (rec['event'] == null || rec.event.length === 0) {
                _this.state.checked = rec.permission;
            }
        }
        if (rec != null) {
            if (rec['event'] != null) {
                for (var _i = 0, _a = rec['event'].sort(sortByDispOrder); _i < _a.length; _i++) {
                    var event_1 = _a[_i];
                    _this.children.push(new EventNode(event_1, _this.id));
                }
            }
        }
        return _this;
    }
    return PageNode;
}(TreeNode));
var EventNode = /** @class */ (function (_super) {
    __extends(EventNode, _super);
    function EventNode(rec, path) {
        var _this = _super.call(this, rec) || this;
        _this.type = 'EVENT';
        _this.li_attr = { class: 'checkTree_event' };
        if (rec['id'] != null) {
            _this.id = path + '/' + (_this.type + "#" + rec.id);
            rec.node_id = _this.id;
        }
        if (rec['permission'] != null) {
            _this.state.checked = rec.permission;
        }
        return _this;
    }
    return EventNode;
}(TreeNode));
var sortByDispOrder = function (n1, n2) {
    if (n1.dispOrder == null) {
        if (n2.dispOrder == null) {
            return 0;
        }
        return 1;
    }
    if (n2.dispOrder == null) {
        return -1;
    }
    if (n1.dispOrder > n2.dispOrder) {
        return 1;
    }
    if (n1.dispOrder < n2.dispOrder) {
        return -1;
    }
    return 0;
};
var ɵ0 = sortByDispOrder;
export { ɵ0 };
//# sourceMappingURL=tree.component.js.map